import { set } from 'lodash/fp';
import createReducer from '../../../helpers/createReducer';
import {
  paginationState,
  resetPaginationState
} from '../../../helpers/pagination';
import { createFetchManyHandler } from '../../../helpers/reducerRoutineCrudHandler';
import { fetchCustomList } from '../../sagas/routines';
import {
  clearCustomList,
  customListOnChangePage,
  customListOnChangeOrder
} from '../../actions';

const initialState = {
  all: {},
  fetching: false,
  fetched: false,
  fetchingError: null,
  pagination: paginationState(),
  order: 'position:asc'
};

const clearCustomListHandler = action => ({
  [action.toString()]: state => ({
    ...state,
    all: {},
    pagination: resetPaginationState(state.pagination)
  })
});

const customListOnChangePageHandler = action => ({
  [action.toString()]: (state, { payload: newZones }) =>
    set('pagination.currentPage', newZones, state)
});

const customListOnChangeOrderHandler = action => ({
  [action.toString()]: (state, { payload: order }) => set('order', order, state)
});

export default createReducer(initialState, {
  ...createFetchManyHandler(fetchCustomList),
  ...clearCustomListHandler(clearCustomList),
  ...customListOnChangePageHandler(customListOnChangePage),
  ...customListOnChangeOrderHandler(customListOnChangeOrder)
});
